// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__-I8dS","savePackageButton":"ClientWallet_savePackageButton__3QX5y"};